var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('panel-frame',{staticClass:"notice-message-link-panel align-center"},[_c('button-base',{staticClass:"notice-message-link-panel__link text-weight-bold",on:{"click":_vm.clickEvent}},[_vm._t("linkLabel")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }